"use strict";

exports.__esModule = true;
exports.StyledPDFViewer = exports.ScrollArea = exports.ProgressIndicator = exports.PrintIframe = exports.PDFViewerDocument = exports.DownloadButton = exports.DocumentErrorMessage = exports.DocumentErrorActions = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ScrollArea = _interopRequireDefault(require("../../layout/ScrollArea/ScrollArea"));

var _ProgressIndicator = _interopRequireDefault(require("../../animations/ProgressIndicator/ProgressIndicator"));

var _Button = _interopRequireDefault(require("../../buttons/Button/Button"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledPDFViewer = _styledComponents.default.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 200px;
    background-color: #525659;
    margin: 0;

    ${({
  theme
}) => theme.colors.pdfViewer.background && (0, _styledComponents.css)`
            background-color: ${theme.colors.pdfViewer.background};
        `}

    ${({
  options
}) => (options == null ? void 0 : options.backgroundColor) && (0, _styledComponents.css)`
            background-color: ${options.backgroundColor};
        `}

    .react-pdf__Document {
        position: relative;
    }

    .react-pdf__Page__canvas {
        margin: 0 auto 15px auto;
        background-color: white;
    }

    .react-pdf__message--loading {
        display: none;
    }

    .scrollbar-container {
        max-height: inherit;
    }

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.borders}
    ${_styledSystem.flexbox}
    ${_styledSystem.position}
`;
exports.StyledPDFViewer = StyledPDFViewer;
const PDFViewerDocument = _styledComponents.default.div`
    width: 100%;
    height: 100%;
    padding-top: 15px;
    opacity: 0;

    ${({
  options
}) => options && options.toolbarPosition === 'top' && (0, _styledComponents.css)`
            padding-top: 45px;
        `}

    ${({
  ready
}) => ready && (0, _styledComponents.css)`
            opacity: 1;
        `}
`;
exports.PDFViewerDocument = PDFViewerDocument;
const StyledScrollArea = (0, _styledComponents.default)(_ScrollArea.default)`
    max-height: 100vh;
    z-index: 0;
`;
exports.ScrollArea = StyledScrollArea;
const StyledProgressIndicator = (0, _styledComponents.default)(_ProgressIndicator.default)`
    position: absolute;
    left: calc(50% - 60px);
    top: calc(50% - 70px);
    z-index: 10;
`;
exports.ProgressIndicator = StyledProgressIndicator;
const DocumentErrorMessage = _styledComponents.default.div`
    position: absolute;
    left: 0;
    right: 0%;
    z-index: 11;
    width: 100%;
    top: calc(50% - 60px);
    text-align: center;
`;
exports.DocumentErrorMessage = DocumentErrorMessage;
const DocumentErrorActions = _styledComponents.default.div`
    margin-top: ${({
  theme
}) => theme.space[5]};
    button {
        margin: 0 ${({
  theme
}) => theme.space[3]};
        width: auto;
    }
`;
exports.DocumentErrorActions = DocumentErrorActions;
const DownloadButton = (0, _styledComponents.default)(_Button.default)``;
exports.DownloadButton = DownloadButton;
const PrintIframe = _styledComponents.default.iframe`
    display: none;
`;
exports.PrintIframe = PrintIframe;